export default "__VITE_ASSET__DTPtYGH1__"